import React from "react";
import { useEffect, useState } from 'react';
import cover from '../../assets/images/Rectangle-1.png'
import { Link } from 'react-router-dom';
import './gammaddasmile.css';

const GammaddaSmiles = () => {


  const [visible, setVisible] = useState(false);

  useEffect(() => {
      const timer = setTimeout(() => {
        setVisible(true);
      }, 500);
      return () => clearTimeout(timer); 
  }, []); 

return (   
      
  <div className="bg-[#fff6ee] text-black   sm:px-6 lg:px-20">
    

          <div className="background-color">  

        <div className="max-w-4xl mx-auto pb-4">   

        <div 
        className="position-relative overflow-hidden w-100" 
        style={{ height: '70vh', maxHeight: '600px' }}
      >
        {/* Background image with overlay */}
        <div 
          className="position-absolute top-0 start-0 w-100 h-100"
          style={{
            backgroundImage: `url(${cover})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            zIndex: 1
          }}
        >
          <div className="w-100 h-100 bg-black" style={{ opacity: 0.5 }}></div>
        </div>
      
  {/* Centered content */}
  <div 
    className="position-absolute top-50 start-50 translate-middle text-center w-100 px-3"
    style={{
      maxWidth: '960px',
      zIndex: 2,
      transition: 'opacity 1s ease, transform 1s ease',
      transform: visible ? 'translate(-50%, -50%)' : 'translate(-50%, -40%)',
      opacity: visible ? 1 : 0
    }}
  >
    <h1 className="fw-bold text-white mb-4 display-5" style={{textTransform:'uppercase', fontFamily: 'Yanone Kaffeesatz,sans-serif'}}>Gammadda Smiles</h1>
   
  </div>
</div>
    
  </div>
  </div>

  <div className="bg-[#fdf7f0] py-15 px-4 md:px-16 custom-padding">
      <div className="max-w-4xl mx-auto text-center">   
        <p className="text-base md:text-lg text-gray-700 mb-8">
          In the face of record food price inflation, skyrocketing fuel costs and 
          widespread commodity shortages, some 9.6 million Sri Lankans, or two in five households 
          are living under the poverty line which has soared to Rs. 13,318, and are unsure of where 
          their next meal is coming from.
        </p>

        <div className="aspect-w-16 aspect-h-9 mb-10" style={{ Width: '1000px', height: 'auto' }}>
          <iframe
            className="w-full h-full custome-iframe"
            src="https://www.youtube.com/embed/C25CgoiosUM?rel=0&controls=1&autoplay=0&mute=0&start=0" 
            title="Gammadda Thakshalawa"
            frameBorder="0"
            allow="autoplay; encrypted-media"
            allowFullScreen
          ></iframe>
          <li className="nav-item " style={{ marginTop: '20px' , marginBottom: '20px' }}>
              <Link to="/make-a-donation" className="button">Donate Now</Link>
              </li>
        </div>

        <div className="text-left space-y-10">
          {/* Ordinary Levels */}
          <div>           
            <p className="text-gray-700 mb-2">
            Amidst a staggering 57.4 percent inflation rate, steeply 
            increasing food prices have crippled the population’s ability to put sufficient and 
            nutritious meals on the table, rendering two in five households without adequate diets.
            </p>            
          </div>

          <div class="container mb-4">
            <div class="ratio ratio-16x9" style={{ maxWidth: '1000px', margin: '0 auto' }}>
              <img 
                src="http://cms.gammadda.lk/wp-content/uploads/2025/05/66abaebec6aed14e82f57cdd_Frame-56.png" 
                alt="Gammadda Smiles" 
                class="img-fluid w-100 h-100 object-fit-cover"
              />
            </div>
          </div>
         <div>           
            <p className="text-gray-700 mb-2">
            More than 40% of Sri Lankans are self employed or are casual daily wage laborers. 
            They are feeling the greatest difficulties during this crisis. As prices keep healthy meals out of reach, 
            some 61 per cent of households are regularly using coping strategies to cut down on costs, such as reducing 
            the amount they eat and consuming increasingly less nutritious meals.
            </p>            
          </div>

          <div class="container mb-4">
            <div class="ratio ratio-16x9" style={{ maxWidth: '1000px', margin: '0 auto' }}>
              <img 
                src="http://cms.gammadda.lk/wp-content/uploads/2025/05/66abaebec6aed14e82f57cdf_Frame-58.png" 
                alt="Gammadda Smiles" 
                class="img-fluid w-100 h-100 object-fit-cover"
              />
            </div>
          </div>

         <div>           
            <p className="text-gray-700 mb-2">
            Gammadda has launched Gammadda Smiles, a dry ration distribution initiative, in which the most needy 
            families will be given a pack of food provisions to help them tide over these difficult times. This is intended to bolster existing 
            food security safety nets and other social security nets in place. This initiative was launched to ensure that our communities do not go hungry.
            </p>            
          </div>

          <div class="container mb-4">
            <div class="ratio ratio-16x9" style={{ maxWidth: '1000px', margin: '0 auto' }}>
              <img 
                src="http://cms.gammadda.lk/wp-content/uploads/2025/05/66abaebec6aed14e82f57cde_Frame-57.png" 
                alt="Gammadda Smiles" 
                class="img-fluid w-100 h-100 object-fit-cover"
              />
            </div>
          </div>

        <div>           
            <p className="text-gray-700 mb-2">
            While it is impossible to help everyone, Gammadda decided that it would do what it can, and is 
            thankful to the kind hearts who time and time again spontaneously come forward in support of this cause.
            </p>            
          </div> 

        </div>
      </div>
    </div>
   
  </div>
);

}

export default GammaddaSmiles